import { Typography, Box, Stack, Pagination } from '@mui/material';
import { useTheme } from '@mui/material';
import { useState, useEffect, useRef } from 'react';
import useProtectedClient from '../../../hooks/useProtectedClient';
import { getAdminOrders } from '../../../api/admin/adminOrderApi';
import AdminOrderItem from './AdminOrderItem';
import ProductRowLoader from '../../marketWidget/productRow/ProductRowLoader';
import SearchBar from '../../base/SearchBar/SearchBar';
import { useNotification } from '../../../context/NotificationProvider';

const AdminOrdersList = () => {
    const [isLoading, setIsLoading] = useState(true)
    const protectedClient = useProtectedClient();
    const [orders, setOrders] = useState([]);
    const [ordersCount, setOrdersCount] = useState([]);
    const {showNotification} = useNotification();
    const page = useRef(1)
    const searchQuery = useRef("")
    const size = 5

    const fetchOrders = async () => {
        try {
            setIsLoading(true)
            const res = await getAdminOrders(protectedClient, searchQuery.current, page.current, size);
            setOrders(res.orders)
            setOrdersCount(res.pagination.totalOrders)
        } catch (error) {
            showNotification(error, "error");
        } finally {
            setIsLoading(false);
        }
    }
    const handleSearch = async (query) => {
        searchQuery.current = query
        page.current = 1
        fetchOrders()
    }
    const handlePageChange = (event, value) => {
        page.current = value
        fetchOrders()
    }
    
    useEffect( () => {
        fetchOrders();
    }, []);
    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            padding={2}
            sx={{ 
                height: "90vh",
                width: "100%",
                marginBottom: "100px",
                overflowY: "auto",
                overflowX: "hidden",
            }}
        >
            <Box
                display="flex"
                flexDirection="row"
                justifyContent="space-between"
                alignItems="center"
                width="100%"
            >
                <SearchBar onSearch={handleSearch} />
                <Typography
                    variant='caption2'
                    width="100%"
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center"
                    }}
                >
                    تعداد سفارشات: {ordersCount}
                </Typography>
            </Box>
            <Stack>
                <Pagination 
                    count={Math.ceil(ordersCount / size)} 
                    page={page.current} 
                    onChange={handlePageChange}
                    color="primary"
                    size="large"
                    shape="circular"
                    siblingCount={0}
                    boundaryCount={1}
                />
            </Stack>

            {!isLoading
            ? 
                <>
                    {orders.map((item, index) => (
                        <AdminOrderItem key={index} item={item} onChange={fetchOrders}/>
                    ))}
                </>
            :
                <>
                    <ProductRowLoader />
                    <ProductRowLoader />
                    <ProductRowLoader />
                </>
            }
            
        </Box>
    );
};

export default AdminOrdersList;
